// src/lib/analytics.js
const CRA = (typeof process !== "undefined" && process.env) || {};
const VITE = (typeof import.meta !== "undefined" && import.meta.env) || {};
const GA4_ID = CRA.REACT_APP_GA4_ID || VITE.VITE_GA4_ID || "";
const IN_BROWSER = typeof window !== "undefined" && typeof document !== "undefined";

let initialized = false;

function ensureGtag() {
  if (!IN_BROWSER) return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

export function initAnalytics() {
  if (!IN_BROWSER || !GA4_ID || initialized) return;
  ensureGtag();
  // Prefer the tag snippet in `public/index.html` so the tag is present in the initial HTML.
  // Keep a fallback injection in case the snippet is removed.
  if (!document.querySelector('script[data-gtag="ga4"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    script.setAttribute("data-gtag", "ga4");
    document.head.appendChild(script);
  }
  initialized = true;
}

export function setAnalyticsConsent(granted) {
  if (!IN_BROWSER || !GA4_ID) return;
  ensureGtag();

  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied",
    ad_storage: "denied",
    personalization_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
}

function safeGtag(...args) {
  if (!IN_BROWSER || !GA4_ID) return;
  ensureGtag();
  window.gtag(...args);
}

export function trackPageView(pathname) {
  if (!IN_BROWSER || !GA4_ID) return;
  const path = pathname || `${window.location.pathname}${window.location.search}`;
  safeGtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title || "",
  });
}

export function trackWhatsAppClick({ buttonLocation } = {}) {
  if (!IN_BROWSER || !GA4_ID) return;
  safeGtag("event", "whatsapp_click", {
    button_location: buttonLocation || "unknown",
    page_path: `${window.location.pathname}${window.location.search}`,
    page_location: window.location.href,
  });
}
